<template>
  <div>
    <Modal width="900"
           v-model="_value"
           :title="titleDisplay"
           @on-visible-change="visibleChange"
           @on-ok="photoRecordModal_ok"
           ok-text="关闭"
           cancel-text="">

      <div class="demo-split">
        <Split v-model="split1">

          <!-- 左侧数据框 -->
          <div slot="left" class="demo-split-pane" style="height:100%;width:100%;">
            <div style="height:100%;width:100%;overflow: auto;padding: 5px;">
              <div v-if="pictureRecords[currentPictureIndex]" style="text-align: center">
                <label v-if="pictureRecords[currentPictureIndex].picType === 1">【身份证/营业执照图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 2">【行驶证图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 3">【车辆交强险单据图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 4">【车辆商业险单据图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 5">【车辆状态图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 6">【承诺函图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 7">【承诺函背面图片】</label>
                <label v-if="pictureRecords[currentPictureIndex].picType === 8">【从业资格证图片】</label>
                {{pictureRecords[currentPictureIndex].key }}
                <a @click="onDownloadClick">【下载图片】</a>
              </div>
              <Carousel v-model="currentPictureIndex" v-if="_value" style="text-align: center;">
                <CarouselItem v-for="item in pictureRecords">
                  <div class="demo-carousel">
                    <img @click="onPhotoClick"
                         :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageMogr2/thumbnail/600x400'"></img>
                  </div>
                </CarouselItem>
              </Carousel>
              <div style="position:relative;">
                <Table border highlight-row size="small" @on-row-click="onRowClick" height="600" :columns="columns"
                       :data="pictureRecords"
                       :height="tableHeight" ref="table"></Table>
                <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoading">
                  <Spin size="large"></Spin>
                  <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
                </div>
              </div>

              <div style="margin-top: 20px;">图片上传</div>
              <div>
                <Select v-model="addPictureRecord.picType">
                  <Option v-for="item in picTypeList" :value="item.val" :key="item.val">{{item.name}}</Option>
                </Select>
                <Upload
                  :before-upload="handleBeforeUpload"
                  action="https://upload-z2.qiniup.com">
                  <Button type="default" icon="ios-cloud-upload-outline">选择上传图片</Button>
                </Upload>
                <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}
                  <Button type="text" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧数据框 -->
          <div slot="right" class="demo-split-pane" style="height:100%;width:100%;">
            <div style="height:100%;width:100%;overflow: auto;padding: 5px;">
              <Form :label-width="80">
                <FormItem label="车牌号:">
                  <div>
                    <Input v-model="rmvehicleinfo.chePaiHao" size="small"
                           clearable
                           placeholder="车牌号"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="车牌颜色:">
                  <div>
<!--                    <Input v-model="rmvehicleinfo.chePaiYanSe" size="small"-->
<!--                           clearable placeholder="车牌颜色"-->
<!--                           style="width: 100%;"></Input>-->
                    <Select v-model="rmvehicleinfo.chePaiYanSe" size="small" style="width: 100%;">
                      <Option v-for="item in chePaiYanSeOptions" :value="item.name" :key="item.value">{{item.name}}</Option>
                    </Select>
                  </div>
                </FormItem>
                <FormItem label="车架号:">
                  <div>
                    <Input v-model="rmvehicleinfo.cheJiaHao" size="small"
                           clearable placeholder="车架号"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="发动机号:">
                  <div>
                    <Input v-model="rmvehicleinfo.faDongJiHao" size="small"
                           clearable placeholder="发动机号"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>

                <FormItem label="地区:">
                  <div>
                    <Select v-model="rmvehicleinfo.area" size="small" style="width: 100%;">
                      <Option v-for="item in certificateAreaOptions" :value="item.name" :key="item.value">
                        {{item.name}}
                      </Option>
                    </Select>
                  </div>
                </FormItem>
                <FormItem v-if="eligibility" label="客户联系人:">
                  <div>
                    <Input v-model="rmvehicleinfo.customerCntact" size="small"
                           clearable placeholder="客户联系人"
                           style="width: 220px;padding: 5px"></Input>
                  </div>
                </FormItem>
                <FormItem v-if="eligibility" label="客户联系人联系方式:">
                  <div>
                    <Input v-model="rmvehicleinfo.customerCntactPhone" size="small"
                           clearable placeholder="客户联系人联系方式"
                           style="width: 220px;padding: 5px"></Input>
                  </div>
                </FormItem>

                <FormItem label="业户名称:">
                  <div>
                    <Input v-model="rmvehicleinfo.yeHuMingCheng" size="small"
                           clearable placeholder="业户名称"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="身份证号码(个体户):">
                  <div>
                    <Input v-model="rmvehicleinfo.shenFenZhengHaoMa" size="small"
                           clearable placeholder="身份证号码"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="业户统一社会信用代码(企业主体):">
                  <div>
                    <Input v-model="rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa" size="small"
                           clearable placeholder="业户统一社会信用代码"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="业户负责人名称:">
                  <div>
                    <Input v-model="rmvehicleinfo.yeHuFuZeRenXingMing"
                           size="small" clearable placeholder="业户负责人名称"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="业户负责人联系方式:">
                  <div>
                    <Input v-model="rmvehicleinfo.yeHuFuZeRenLianXiFangShi"
                           size="small" clearable placeholder="业户负责人联系方式"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="司机姓名:">
                  <div>
                    <Input v-model="rmvehicleinfo.siJiXingMing" size="small"
                           clearable placeholder="司机姓名"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="从业资格证号:">
                  <div>
                    <Input v-model="rmvehicleinfo.congYeZiGeZhengHao" size="small"
                           clearable placeholder="从业资格证号"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="司机联系方式:">
                  <div>
                    <Input v-model="rmvehicleinfo.siJiLianXiFangShi"
                           size="small"
                           clearable placeholder="司机联系方式"
                           style="width: 100%;"></Input>
                  </div>
                </FormItem>
                <FormItem label="交强险公司:">
                  <div>
                    <Select
                      size="small"
                      placeholder="交强险公司"
                      v-model="rmvehicleinfo.jiaoQiangXianGongSi"
                      filterable
                      remote
                      :remote-method="searchMLIFTAinsuranceChannel"
                      :loading="searchMLIFTAinsuranceChannelLoading"
                      class="field" style="width: 100%;"
                      placement="top-start"
                      clearable>
                      <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.name"
                              :key="option.id">{{option.name}}
                      </Option>
                    </Select>
                  </div>
                </FormItem>
                <FormItem label="交强险到期时间:">
                  <div>
                    <DatePicker type="date" v-model="rmvehicleinfo.jiaoQiangXianDaoQiShiJian" size="small"
                                placement="bottom-end"
                                placeholder="交强险到期时间"></DatePicker>
                  </div>
                </FormItem>
                <FormItem label="商业险公司:">
                  <div>
                    <Select
                      size="small"
                      placeholder="商业险公司"
                      v-model="rmvehicleinfo.shangYeXianGongSi"
                      filterable
                      remote
                      :remote-method="searchTIinsuranceChannel"
                      :loading="searchTIinsuranceChannelLoading"
                      class="field" style="width: 100%;"
                      placement="top-start"
                      clearable>
                      <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.name"
                              :key="option.id">{{option.name}}
                      </Option>
                    </Select>
                  </div>
                </FormItem>
                <FormItem label="商业险到期时间:">
                  <div>
                    <DatePicker type="date" v-model="rmvehicleinfo.shangYeXianDaoQiShiJian" size="small"
                                placement="top-end"
                                placeholder="商业险到期时间"></DatePicker>
                  </div>
                </FormItem>
                <Input v-model="rmvehicleinfo.remark"
                       disabled="true"
                       size="small"
                       type="textarea"
                       :autosize="true"
                       clearable placeholder="备注"
                       style="width: 100%;margin-bottom: 5px;padding-bottom: 30px;"></Input>
                <div style="position: absolute;bottom: 10px;right: 30px;">
                <Button type="info" size="small" style="margin-right: 10px;" @click="modifyRmvehicleinfo">
                  确认修改
                </Button>
                <!--                <Button type="info" size="small" style="margin-right: 5px;">-->
                <!--                  追加备注-->
                <!--                </Button>-->
                <Button type="info" size="small" @click="onFreeInstallationAuditAddAuditPassModal">
                  审核结果
                </Button>
                </div>
              </Form>

            </div>
          </div>

        </Split>
      </div>

    </Modal>

    <free-installation-audit-add-audit-pass-modal v-model="freeInstallationAuditAddAuditPassModal"
                                                  :initValue="freeInstallationAuditAddAuditPassId"
                                                  @on-success="onSuccess"></free-installation-audit-add-audit-pass-modal>
  </div>

</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import axios from 'axios'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  import FreeInstallationAuditAddAuditPassModal from '@/view/crm/components/free-installation-audit-add-auditPass-modal'

  export default {
    name: 'FreeInstallationAuditPictureModal',
    components: {
      FreeInstallationAuditAddAuditPassModal
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {

        // 重货保险免费安装主动安全设备登记审核审核结果
        freeInstallationAuditAddAuditPassModal: false,
        freeInstallationAuditAddAuditPassId: null,

        split1: 0.65,

        // 交强险选择
        searchMLIFTAinsuranceChannelList: [],
        searchMLIFTAinsuranceChannelLoading: false,

        // 商业险选择
        searchTIinsuranceChannelList: [],
        searchTIinsuranceChannelLoading: false,

        chePaiYanSeOptions: [
          {name: '蓝色', value: 1},
          {name: '黄色', value: 2},
          {name: '黑色', value: 3},
          {name: '白色', value: 4},
          {name: '渐变绿色', value: 5},
          {name: '黄绿色', value: 6 },
        ],

        certificateAreaOptions: [
          {name: '中山', value: 1},
          {name: '江门', value: 2}
        ],

        currentPictureIndex: 0,

        titleDisplay: '图片管理',
        rmvehicleinfo: {
          id: null,
          chePaiHao: null,
          chePaiYanSe: null,
          cheJiaHao: null,
          faDongJiHao: null,
          yeHuMingCheng: null,
          shenFenZhengHaoMa: null,
          area: null,
          yeHuTongYiSheHuiXinYongDaiMa: null,
          yeHuFuZeRenXingMing: null,
          yeHuFuZeRenLianXiFangShi: null,
          siJiXingMing: null,
          congYeZiGeZhengHao: null,
          siJiLianXiFangShi: null,
          jiaoQiangXianGongSi: null,
          jiaoQiangXianDaoQiShiJian: null,
          shangYeXianGongSi: null,
          shangYeXianDaoQiShiJian: null,
          businessuserid: null,
          idPass: null,
          remark: null,
          customerCntact: null,
          customerCntactPhone: null,
          /**
           * 图片部分
           */
          idFilePictureId: null, // 车主身份证明文件图片id
          idFilePicture: null, // 车主身份证明文件图片
          vehicleLicensePictureId: null, // 行驶证图片id
          vehicleLicensePicture: null, // 行驶证图片
          mandatoryLiabilityInsuranceForTrafficAccidentsPictureId: null, // 车辆交强险单据图片id
          mandatoryLiabilityInsuranceForTrafficAccidentsPicture: null, // 车辆交强险单据图片
          commercialInsurancePictureId: null, // 车辆商业险单据图片id
          commercialInsurancePicture: null, // 车辆商业险单据图片
          vehicleInfoStatePictureId: null, // 车辆状态图片id
          vehicleInfoStatePicture: null, // 车辆状态图片
          commitmentLetterPictureId: null, // 承诺函图片id
          commitmentLetterPicture: null, // 承诺函图片
          commitmentLetterBackPictureId: null, // 承诺函背面图片id
          commitmentLetterBackPicture: null, // 承诺函背面图片
          qualificationCertificatePictureId: null, // 从业资格证图片id
          qualificationCertificatePicture: null// 从业资格证图片
        },

        tableHeight: 140,
        listLoading: false,
        loadingStatus: false,
        pictureRecords: [],
        columns: [
          {
            title: 'picKey',
            key: 'picKey',
            ellipsis: 'true',
            minWidth: 250
          },
          {
            title: '图片类型',
            key: 'picType',
            ellipsis: 'true',
            minWidth: 100,
            render: (h, params) => {
              return h('Button', {
                  // style: { width: '80px' },
                  props: {
                    // value: this.data[params.index].volumeType,
                    // value: params.row.picType,
                    // disabled: !params.row.modify
                  },
                  on: {
                    click: (event) => {
                      // params.row.picType = event
                      // console.log(params.row.picType)
                    }
                  }
                },

                params.row.picType == 1 ? '身份证/营业执照'
                  : params.row.picType == 2 ? '行驶证'
                  : params.row.picType == 3 ? '车辆交强险单据'
                    : params.row.picType == 4 ? '车辆商业险单据'
                      : params.row.picType == 5 ? '车辆状态'
                        : params.row.picType == 6 ? '承诺函'
                          : params.row.picType == 7 ? '承诺函背面'
                            : params.row.picType == 8 ? '从业资格证' : '其他'
              )
            }
          }
          //   {
          //   title: '操作',
          //   key: 'action',
          //   align: 'center',
          //   ellipsis: 'true',
          //   minWidth: 250,
          //   render: (h, params) => {
          //     return h('div', [
          //       h('Button', {
          //         props: {
          //           shape: 'circle',
          //           type: 'error',
          //           size: 'small',
          //           disabled: false
          //         },
          //         on: {
          //           click: () => {
          //             this.onDeleteBtnClick(params.row.id)
          //           }
          //         }
          //       }, '删除')]
          //     );
          //   }
          // }
        ],
        addPictureRecord: {
          picKey: null,
          srcHeight: null,
          srcWidth: null,
          picType: 1
        },
        picTypeList: [
          {name: '身份证/营业执照', val: 1},
          {name: '行驶证', val: 2},
          {name: '车辆交强险单据', val: 3},
          {name: '车辆商业险单据', val: 4},
          {name: '车辆状态', val: 5},
          {name: '承诺函', val: 6},
          {name: '承诺函背面', val: 7},
          {name: '从业资格证', val: 8}
        ],
        postParams: {
          upload_token: null
        },
        uploadFile: null
      }
    },
    methods: {
      ...mapActions([
        'PictureServ_GetQiniuUploadToken',
        'PictureServ_AddObj',
        'PictureServ_DeleteObj',
        'VehicleInfoServ_GetDetail',
        'VehicleInfoServ_ChangePicture'
      ]),
      onSuccess() {
        this.loadPhotoRecords()
        this.$emit('on-success')
      },
      onRowClick(item, index) {
        this.currentPictureIndex = index
      },
      onDownloadClick() {
        let item = this.pictureRecords[this.currentPictureIndex]
        window.open('https://pic.jianchengjt.com/' + item.picKey + '?attname=' + item.picKey + '.jpg')
      },
      onPhotoClick() {
        let item = this.pictureRecords[this.currentPictureIndex]
        window.open('https://pic.jianchengjt.com/' + item.picKey)
      },
      onDeleteBtnClick(id) {
        // store.dispatch('PictureServ_DeleteObj', {
        //   params: {id: id},
        //   urlparams: null
        // }).then(() => {
        //   this.$Message.success('删除照片成功');
        //   store.dispatch('PictureServ_GetHousePhotos', {
        //     params: {id: this._housingResourceId},
        //     urlparams: null
        //   }).then(() => {
        //     this.pictureRecords = store.getters.get_PhotoRecord_GetHousePhotosResult;
        //   }).catch(err => {
        //     this.$Message.error(err);
        //   });
        // }).catch(err => {
        //   this.$Message.error(err);
        // });
      },
      visibleChange(val) {
        if (val) {
          this.uploadFile = null
          this.rmvehicleinfo.jiaoQiangXianGongSi = null
          this.rmvehicleinfo.shangYeXianGongSi = null
          this.loadPhotoRecords()
        }
      },
      upload() {
        console.log('开始上传')
        let param = new FormData() // 创建form对象
        param.append('chunk', '0')// 断点传输
        param.append('chunks', '1')
        param.append('key', this.postParams.picKey)
        param.append('file', this.uploadFile, this.uploadFile.name)
        param.append('token', this.postParams.upload_token)

        let config = {
          headers: {'Content-Type': 'multipart/form-data'},
          withCredentials: false
        }
        this.loadingStatus = true

        axios.post('https://upload-z2.qiniup.com', param, config)
          .then(response => {
            console.log(response.data)
            this.addPictureRecord.picKey = this.postParams.picKey
            store.dispatch('RmFreeServ_UploadInstallorderePicture', {
              params: {
                id: this._initValue,
                picKey: this.addPictureRecord.picKey,
                picType: this.addPictureRecord.picType,
                srcWidth: this.addPictureRecord.srcWidth,
                srcHeight: this.addPictureRecord.srcHeight
              },
              urlparams: null
            }).then(() => {
              this.loadingStatus = false
              this.$Message.success('添加图片成功')
              this.uploadFile = null
              this.loadPhotoRecords()
            }).catch(err => {
              this.loadingStatus = false
              this.$Message.error(err)
            })
          }).catch(err1 => {
          this.$Message.error(err1)
          this.loadingStatus = false
        })
      },
      photoRecordModal_ok() {

      },
      handleView(name) {
        this.imgName = name
        this.visible = true
      },
      handleRemove(file) {
        const fileList = this.$refs.upload.fileList
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
      },
      handleSuccess(res, file) {
        file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar'
        file.name = '7eb99afb9d5f317c912f08b5212fd69a'
      },
      handleFormatError(file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        })
      },
      handleMaxSize(file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        })
      },
      handleBeforeUpload(file) {
        console.log('handleBeforeUpload')
        store.dispatch('PictureServ_GetQiniuUploadToken', {
          params: {head: 'RMVEHICLEINFO'},
          urlparams: null
        }).then(() => {
          this.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
          this.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
          this.uploadFile = file
          console.log('PictureServ_GetQiniuUploadToken ok')
        }).catch(err => {
          this.$Message.error(err)
        })
        return false
      },
      loadPhotoRecords() {
        store.dispatch('RmFreeServ_GetDetail', {
          params: {id: this._initValue},
          urlparams: null
        }).then(() => {
          let title = null
          this.rmvehicleinfo = store.getters.get_RmFree_GetDetailResult
          let rmvehicleinfo = store.getters.get_RmFree_GetDetailResult
          if (this.rmvehicleinfo.chePaiHao) {
            title = this.rmvehicleinfo.chePaiHao
          } else if (this.rmvehicleinfo.vin) {
            title = this.rmvehicleinfo.cheJiaHao
          }
          this.titleDisplay = '图片管理 【' + title + '】'
          this.pictureRecords = []
          if (rmvehicleinfo.idFilePicture) {
            this.pictureRecords.push(rmvehicleinfo.idFilePicture)
          }
          if (rmvehicleinfo.vehicleLicensePicture) {
            this.pictureRecords.push(rmvehicleinfo.vehicleLicensePicture)
          }
          if (rmvehicleinfo.mandatoryLiabilityInsuranceForTrafficAccidentsPicture) {
            this.pictureRecords.push(rmvehicleinfo.mandatoryLiabilityInsuranceForTrafficAccidentsPicture)
          }
          if (rmvehicleinfo.commercialInsurancePicture) {
            this.pictureRecords.push(rmvehicleinfo.commercialInsurancePicture)
          }
          if (rmvehicleinfo.vehicleInfoStatePicture) {
            this.pictureRecords.push(rmvehicleinfo.vehicleInfoStatePicture)
          }
          if (rmvehicleinfo.commitmentLetterPicture) {
            this.pictureRecords.push(rmvehicleinfo.commitmentLetterPicture)
          }
          if (rmvehicleinfo.commitmentLetterBackPicture) {
            this.pictureRecords.push(rmvehicleinfo.commitmentLetterBackPicture)
          }
          if (rmvehicleinfo.qualificationCertificatePicture) {
            this.pictureRecords.push(rmvehicleinfo.qualificationCertificatePicture)
          }
          this.pictureRecords.forEach(item => {
            Vue.set(item, 'modify', false)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      // 交强险搜索
      searchMLIFTAinsuranceChannel(input) {
        this.searchMLIFTAinsuranceChannelLoading = true
        if (!input || input.length <= 0) {
          this.searchMLIFTAinsuranceChannelList = []
          this.searchMLIFTAinsuranceChannelLoading = false
        } else {
          store.dispatch('InsuranceChannelServ_SearchByName', {
            params: {name: input},
            urlparams: null
          }).then(() => {
            this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
            this.searchMLIFTAinsuranceChannelLoading = false
          }).catch(err => {
            this.searchMLIFTAinsuranceChannelLoading = false
          })
        }
      },
      searchTIinsuranceChannel(input) {
        this.searchTIinsuranceChannelLoading = true
        if (!input || input.length <= 0) {
          this.searchTIinsuranceChannelList = []
          this.searchTIinsuranceChannelLoading = false
        } else {
          store.dispatch('InsuranceChannelServ_SearchByName', {
            params: {name: input},
            urlparams: null
          }).then(() => {
            this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
            this.searchTIinsuranceChannelLoading = false
          }).catch(err => {
            this.searchTIinsuranceChannelLoading = false
          })
        }
      },
      // 修改锐明保险资料
      modifyRmvehicleinfo() {
        this.$Modal.confirm({
          title: '确认修改',
          content: '<p>注意：确认修改重货保险免费安装主动安全设备登记</p>',
          onOk: () => {
            if (this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != null && this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != '') {
              if (new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian) < new Date()) {
                this.$Message.error('交强险已过期')
                return
              } else {
                this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian).Format('yyyy-MM-dd')
              }
            } else {
              this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = null
            }
            if (this.rmvehicleinfo.shangYeXianDaoQiShiJian != null && this.rmvehicleinfo.shangYeXianDaoQiShiJian != '') {
              if (new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian) < new Date()) {
                this.$Message.error('商业险已过期')
                return
              } else {
                this.rmvehicleinfo.shangYeXianDaoQiShiJian = new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian).Format('yyyy-MM-dd')
              }
            } else {
              this.rmvehicleinfo.shangYeXianDaoQiShiJian = null
            }
            if (this.rmvehicleinfo.shenFenZhengHaoMa == '') {
              this.rmvehicleinfo.shenFenZhengHaoMa = null
            }
            if (this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa == '') {
              this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa = null
            }
            if (this.rmvehicleinfo.customerCntact == '') {
              this.rmvehicleinfo.customerCntact = null
            }
            if (this.rmvehicleinfo.customerCntactPhone == '') {
              this.rmvehicleinfo.customerCntactPhone = null
            }
            store.dispatch('RmFreeServ_ModifyObj', {
              params: this.rmvehicleinfo,
              urlparams: {}
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              console.log(err)
              this.$Message.error(err)
            })
          },
          onCancel: () => {
          }
        })
      },
      onFreeInstallationAuditAddAuditPassModal() {
        this.freeInstallationAuditAddAuditPassModal = true
        this.freeInstallationAuditAddAuditPassId = this._initValue
      }
    },
    mounted() {
      // this.uploadList = this.$refs.upload.fileList;
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    }
  }
</script>

<style scoped>
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-carousel {
    height: 400px;
    width: 600px;
    /*line-height: 200px;*/
    text-align: center;
    color: #fff;
    font-size: 20px;
    background-color: #506b9e;
  }

  .demo-carousel img {
    height: 400px;
    width: 600px;
  }

  .demo-split {
    height: 700px;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
